import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';

export interface DashboardStatsDto {
  totalFornecedores: number;
  fornecedoresAtivos: number;
  fornecedoresInativos: number;
  novosFornecedoresSemana: number;
  fornecedoresFree: number;
  fornecedoresVitrine: number;
  totalLeadsHoje: number;
  totalLeadsMes: number;
  leadsNaoLidos: number;
  mrr: number;
  rendaPrevista: number;
  assinaturasVencendo30Dias: number;
  removalRequests: number;
  pendingAdhesions: number;
}

export interface SupplierByCategoryPlanDto {
  categoriaId: string;
  categoriaNome: string;
  free: number;
  vitrine: number;
  total: number;
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  constructor(private api: ApiService) {}

  getStats(): Observable<DashboardStatsDto> {
    return this.api.get<DashboardStatsDto>('/admin/dashboard');
  }

  getActiveSuppliersByCategoryAndPlan(): Observable<SupplierByCategoryPlanDto[]> {
    return this.api.get<SupplierByCategoryPlanDto[]>('/admin/dashboard/fornecedores-ativos-por-categoria-plano');
  }
}
